export default __webpack_public_path__ + "static/media/cropped-Spiritual-Eye-Joy-Logo-C.77632897.jpg";